import { SpecialColumnsIds } from '../SpecialColumns';

/** Render-only: keep Actions as the rightmost cell without changing column state. */
export const withActionsLast = <T,>(items: T[], getColumnId: (item: T) => string): T[] => {
  const actionsIndex = items.findIndex((item) => getColumnId(item) === SpecialColumnsIds.ACTIONS);
  if (actionsIndex === -1 || actionsIndex === items.length - 1) {
    return items;
  }

  const next = [...items];
  const [actionsItem] = next.splice(actionsIndex, 1);
  next.push(actionsItem);
  return next;
};
